import React from "react";
import { FiSun } from "react-icons/fi";
import { FaLeaf, FaSnowflake, FaMinus } from "react-icons/fa";
import { RiPlantLine } from "react-icons/ri";
import { AiFillQuestionCircle } from "react-icons/ai";
import ReactTooltip from "react-tooltip";

function SeasonGrades(props) {
  const { seasonGrades, formValues } = props;

  return (
    <div className="Season-Grades-Container">
      <div className="SeasonGradeHeader">
        <h3>Seasonal Boost Scores</h3>
        <AiFillQuestionCircle
          className="QuestionIcon"
          data-tip="
          We run a model developed by NREL (National Renewable Energy Lab) with atmospheric data 
          collected by NASA to figure out the raw solar spectrum for your greenhouse's location.
          Then we run another process that determines how UbiGro
          will change that raw solar spectrum. We compare that result with 
          many other locations (some good, some bad) to create the Boost Score. "
        />
        <ReactTooltip />
      </div>
      <div className="Season-Grades">
        <div className="Spring-Grade">
          <RiPlantLine className="SpringIcon" />
          {seasonGrades ? (
            <p>
              {formValues.latitude > 0
                ? seasonGrades[1].spring
                : seasonGrades[3].fall}
              %
            </p>
          ) : (
            <p>
              <FaMinus />
            </p>
          )}
        </div>
        <div className="Summer-Grade">
          <FiSun className="SummerIcon" />
          {seasonGrades ? (
            <p>
              {formValues.latitude > 0
                ? seasonGrades[2].summer
                : seasonGrades[0].winter}
              %
            </p>
          ) : (
            <p>
              <FaMinus />
            </p>
          )}
        </div>
        <div className="Fall-Grade">
          <FaLeaf className="FallIcon" />
          {seasonGrades ? (
            <p>
              {formValues.latitude > 0
                ? seasonGrades[3].fall
                : seasonGrades[1].spring}
              %
            </p>
          ) : (
            <p>
              <FaMinus />
            </p>
          )}
        </div>
        <div className="Winter-Grade">
          <FaSnowflake className="WinterIcon" />
          {seasonGrades ? (
            <p>
              {formValues.latitude > 0
                ? seasonGrades[0].winter
                : seasonGrades[2].summer}
              %
            </p>
          ) : (
            <p>
              <FaMinus />
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default SeasonGrades;
